import { createFileRoute, notFound } from "@tanstack/react-router"
import LandingPageView from "@/components/landing-page"
import { BRUNCH_PAGE } from "@/lib/data/landing/brunch"
import { buildLandingHead } from "@/lib/utils/landing-head"

const SUPPORTED_COUNTRY_CODES = new Set(["us"])

export const Route = createFileRoute("/$countryCode/brunch")({
  loader: ({ params }) => {
    if (!SUPPORTED_COUNTRY_CODES.has(params.countryCode.toLowerCase())) {
      throw notFound()
    }
    return { countryCode: params.countryCode }
  },
  head: () => buildLandingHead(BRUNCH_PAGE),
  component: () => <LandingPageView page={BRUNCH_PAGE} />,
})
